import { render } from "./Tab.vue?vue&type=template&id=6544de4b&scoped=true"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"

import "./Tab.vue?vue&type=style&index=0&id=6544de4b&scoped=true&lang=css"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6544de4b"]])

export default __exports__